mutation DeleteDocumentsMutation($ids: [ID!]!) {
  deleteDocuments(ids: $ids) {
    id
  }
}
